import {
  CustomFieldWithValue,
  MultiOptionValue,
} from '@/core/interfaces/common';
import { FormInput } from '@/core/components/FormInput';
import { FormSelect } from '@/core/components/FormSelect';
import { FormMultipleSelect } from '@/core/components/FormMultipleSelect';

import {
  fieldTypes,
} from '@/utils/constants';

interface CustomFormInputProps {
  backgroundcolor: string;
  error: () => string | false;
  customFieldData: CustomFieldWithValue;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onMultiChange: (values: Array<MultiOptionValue>) => void;
  onFocus: () => void;
}

export const CustomFormInput = ({
  backgroundcolor,
  customFieldData: {
    fieldType,
    options,
    label,
    uuid,
    value,
    values,
  },
  error,
  onChange,
  onMultiChange,
  onFocus,
}: CustomFormInputProps) => {
  switch (fieldType) {
    case fieldTypes.textField:
      return (
        <FormInput
          backgroundcolor={backgroundcolor}
          error={error}
          name="customField"
          type="text"
          label={label}
          onChange={onChange}
          onFocus={onFocus}
          value={value}
        />
      );
    case fieldTypes.singleChoiceField:
      return (
        <FormSelect
          backgroundcolor={backgroundcolor}
          error={error}
          name={label}
          options={options}
          onChange={onChange}
          onFocus={onFocus}
          value={value}
        />
      );
    case fieldTypes.multipleChoiceField:
      return (
        <FormMultipleSelect
          backgroundcolor={backgroundcolor}
          error={error}
          name={label}
          options={options}
          onMultiChange={onMultiChange}
          onFocus={onFocus}
          values={values}
        />
      );
    default:
      return <></>;
  }
};
